/* pl-main.js — comportements de la réplique (vanilla, Swiper 11 chargé avant) */
(function () {
  'use strict';
  if (window.__plMainLoaded) return;
  window.__plMainLoaded = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- helpers vidéo ---------- */
  function toggleVideo(wrapper, video) {
    if (!video) return;
    if (video.paused) {
      video.play().then(function () { wrapper.classList.add('is-playing'); }).catch(function () {});
      wrapper.classList.add('is-playing');
    } else {
      video.pause();
      wrapper.classList.remove('is-playing');
    }
  }

  /* ---------- fiche produit ---------- */
  function initMainProduct(root) {
    var mainEl = root.querySelector('.swiper-main');
    var thumbsEl = root.querySelector('.swiper-thumbnails');
    var thumbs = null, main = null;

    if (window.Swiper && thumbsEl) {
      thumbs = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        navigation: {
          prevEl: root.querySelector('.product-gallery .swiper-button-prev-custom'),
          nextEl: root.querySelector('.product-gallery .swiper-button-next-custom')
        }
      });
    }
    if (window.Swiper && mainEl) {
      main = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 8,
        pagination: { el: mainEl.querySelector('.swiper-pagination'), clickable: true },
        thumbs: thumbs ? { swiper: thumbs } : undefined
      });
      main.on('slideChange', function () {
        mainEl.querySelectorAll('video').forEach(function (v) { v.pause(); v.closest('[data-video]') && v.closest('[data-video]').classList.remove('is-playing'); });
      });
    }

    // vidéos de la galerie : clic = lecture / pause
    root.querySelectorAll('.swiper-main [data-video]').forEach(function (w) {
      w.addEventListener('click', function () { toggleVideo(w, w.querySelector('video')); });
    });

    // couleurs
    var form = root.querySelector('form[data-pl-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var titleEl = root.querySelector('[data-current-color]');
    var newBadge = root.querySelector('[data-new-badge]');
    function applyColor(input) {
      var name = input.getAttribute('data-color-name');
      var vid = input.value;
      if (idInput && vid) idInput.value = vid;
      if (titleEl) titleEl.textContent = name;
      if (newBadge) newBadge.style.display = input.getAttribute('data-new') === 'true' ? '' : 'none';
      // barre sticky
      var stickyName = root.querySelector('[data-sticky-color-name]');
      var stickySw = root.querySelector('[data-sticky-color-swatch]');
      if (stickyName) stickyName.textContent = name;
      if (stickySw) {
        var src = input.getAttribute('data-swatch-src');
        var col = input.getAttribute('data-swatch-color');
        if (src) { stickySw.style.backgroundImage = 'url(' + src + ')'; stickySw.style.backgroundColor = ''; }
        else { stickySw.style.backgroundImage = ''; stickySw.style.backgroundColor = col || '#000'; }
      }
      // filtre galerie par couleur si des médias portent la couleur dans leur alt
      if (main) {
        var slides = mainEl.querySelectorAll('.swiper-slide');
        var tagged = Array.prototype.filter.call(slides, function (s) { return (s.getAttribute('data-colors') || '').length; });
        if (tagged.length) {
          var lower = name.toLowerCase();
          slides.forEach(function (s) {
            var cols = (s.getAttribute('data-colors') || '').toLowerCase();
            var show = !cols || cols.indexOf(lower) !== -1;
            s.style.display = show ? '' : 'none';
          });
          if (thumbs) {
            thumbsEl.querySelectorAll('.swiper-slide').forEach(function (s) {
              var cols = (s.getAttribute('data-colors') || '').toLowerCase();
              s.style.display = (!cols || cols.indexOf(lower) !== -1) ? '' : 'none';
            });
            thumbs.update();
          }
          main.update(); main.slideTo(0, 0);
        }
      }
      // synchro des deux jeux de radios (fiche + sticky)
      root.querySelectorAll('input[data-color-name]').forEach(function (other) {
        if (other !== input && other.getAttribute('data-color-name') === name) other.checked = true;
      });
    }
    root.querySelectorAll('input[data-color-name]').forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) applyColor(input); });
    });
    var checked = root.querySelector('input[data-color-name]:checked');
    if (checked) applyColor(checked);

    // accordéons (un seul ouvert)
    root.querySelectorAll('.accordions').forEach(function (group) {
      group.querySelectorAll('.accordion-item').forEach(function (item) {
        var btn = item.querySelector('.accordion');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          group.querySelectorAll('.accordion-item').forEach(function (i) { i.classList.remove('is-open'); });
          if (!open) item.classList.add('is-open');
        });
      });
    });

    // vidéo "mode d'emploi"
    root.querySelectorAll('.video-wrapper[data-video]').forEach(function (w) {
      var poster = w.querySelector('.poster-image-wrapper');
      var video = w.querySelector('video');
      w.addEventListener('click', function () {
        if (poster) poster.style.display = 'none';
        if (video) { video.classList.remove('hidden'); video.controls = true; toggleVideo(w, video); }
      });
    });

    // carrousels UGC (desktop + mobile)
    root.querySelectorAll('.video-carousel-swiper').forEach(function (el) {
      var nav = el.parentElement.querySelector('.swiper-custom-nav') || el.nextElementSibling;
      var sw = window.Swiper ? new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: nav ? { prevEl: nav.querySelector('.swiper-button-prev-custom'), nextEl: nav.querySelector('.swiper-button-next-custom') } : undefined
      }) : null;
      el.querySelectorAll('.video-wrapper-new').forEach(function (w) {
        var video = w.querySelector('video');
        w.addEventListener('click', function () {
          if (!video) return;
          el.querySelectorAll('video').forEach(function (v) { if (v !== video) { v.pause(); v.closest('.video-wrapper-new').classList.remove('is-playing'); } });
          video.muted = false;
          toggleVideo(w, video);
        });
      });
      if (sw) sw.on('slideChange', function () { el.querySelectorAll('video').forEach(function (v) { v.pause(); v.closest('.video-wrapper-new').classList.remove('is-playing'); }); });
    });

    // barre sticky
    var sticky = root.querySelector('#stickyATC');
    var trigger = root.querySelector('.sticky-atc-trigger');
    if (sticky && trigger) {
      var update = function () {
        var r = trigger.getBoundingClientRect();
        var past = r.bottom < 0;
        var atBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 200);
        sticky.classList.toggle('is-visible', past && !atBottom);
      };
      window.addEventListener('scroll', update, { passive: true });
      update();

      root.querySelectorAll('.pl-dropdown').forEach(function (dd) {
        var toggle = dd.querySelector('.pl-dropdown-toggle');
        toggle && toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = dd.classList.contains('is-open');
          root.querySelectorAll('.pl-dropdown').forEach(function (d) { d.classList.remove('is-open'); });
          if (!open) dd.classList.add('is-open');
        });
        dd.querySelectorAll('input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var label = dd.querySelector('[data-dropdown-label]');
            if (label && inp.getAttribute('data-label')) label.textContent = inp.getAttribute('data-label');
            dd.classList.remove('is-open');
          });
        });
      });
      document.addEventListener('click', function () { root.querySelectorAll('.pl-dropdown').forEach(function (d) { d.classList.remove('is-open'); }); });

      var stickyBtn = sticky.querySelector('[data-sticky-add]');
      stickyBtn && stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var qtyInput = sticky.querySelector('input[name="sticky-qty"]:checked');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        var q = form && form.querySelector('input[name="quantity"]');
        if (q) q.value = qty;
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    // ajout panier
    // Sans MoonBundle : fetch puis page panier.
    // Avec MoonBundle : on garde la main (preventDefault → son écouteur de submit s'efface) et on
    // construit nous-mêmes les lignes de bundle : une ligne par flacon (propriété cachée _u, pour que
    // la couleur de chaque flacon soit modifiable dans le tiroir) portant la propriété __moonbundle
    // que l'app attend ({offer_id, bundle_id, config_id, main_product_id, market_added, type}), en UN
    // appel `cart/add.js?moonbundle_ignore=true`. Passer par l'intercepteur de MoonBundle donnait
    // une ligne de quantité 2 qu'il fallait scinder après coup : l'app ouvrait le tiroir avec
    // « 1 produit × 2 » avant que la scission ne le re-rende en deux lignes. Le chemin intercepteur +
    // scission reste en secours si le widget ne fournit pas ce qu'il faut.
    // Puis on ouvre le tiroir MoonBundle (pas d'adaptateur Horizon dans l'app : sans ça, MoonBundle
    // redirigerait vers /cart).
    if (form) {
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      var postJson = function (url, body) {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); });
      };
      var isBundleLine = function (item) {
        try { return JSON.parse(item.properties.__moonbundle).type === 'bundle'; } catch (err) { return false; }
      };
      var splitBundleLines = function () {
        return fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
          var lines = cart.items.filter(function (i) { return i.quantity > 1 && i.properties && isBundleLine(i); });
          return lines.reduce(function (chain, line) {
            return chain.then(function () {
              var extra = [];
              for (var k = 1; k < line.quantity; k++) {
                var props = {}; for (var key in line.properties) props[key] = line.properties[key];
                props._u = String(Date.now()) + k;
                extra.push({ id: line.variant_id, quantity: 1, properties: props });
              }
              return postJson(root + 'cart/change.js?moonbundle_ignore=true', { id: line.key, quantity: 1 })
                .then(function () { return postJson(root + 'cart/add.js?moonbundle_ignore=true', { items: extra }); });
            });
          }, Promise.resolve());
        });
      };
      var openDrawer = function () {
        var mb = document.querySelector('moonbundle-cart-drawer-block');
        if (!mb) { window.location.href = root + 'cart'; return; }
        var p = typeof mb.loadCart === 'function' ? mb.loadCart() : Promise.resolve();
        Promise.resolve(p).catch(function () {}).then(function () { if (typeof mb.open === 'function') mb.open(); });
      };
      // lignes de bundle prêtes à ajouter (null si le widget n'est pas exploitable → chemin de secours)
      var buildBundleLines = function (fd) {
        try {
          var comp = document.querySelector('moonbundle-component');
          var active = document.querySelector('.moonbundle-option-active');
          var wrapper = active && active.closest('.moonbundle-option-wrapper');
          var offerId = wrapper && wrapper.getAttribute('data-offer-id');
          var variantId = parseInt(fd.get('id'), 10);
          if (!comp || !offerId || !variantId) return null;
          var bundle = JSON.parse(comp.getAttribute('bundle'));
          var mainProduct = JSON.parse(comp.getAttribute('main-product'));
          var config = null, offer = null;
          (bundle.configs || []).forEach(function (c) {
            (c.offers || []).forEach(function (o) { if (o.id === offerId) { config = c; offer = o; } });
          });
          var qty = offer && parseInt(offer.qty, 10);
          if (!config || !qty || qty < 1) return null;
          var prop = JSON.stringify({
            offer_id: offerId, bundle_id: bundle.id, config_id: config.id,
            main_product_id: String(mainProduct.id),
            market_added: (window.Shopify && window.Shopify.country) || '', type: 'bundle'
          });
          var items = [], stamp = String(Date.now());
          for (var k = 0; k < qty; k++) items.push({ id: variantId, quantity: 1, properties: { __moonbundle: prop, _u: stamp + k } });
          return items;
        } catch (err) { return null; }
      };
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        btn && btn.classList.add('is-loading');
        var fd = new FormData(form);
        var hasMb = !!document.querySelector('moonbundle-component');
        var lines = hasMb ? buildBundleLines(fd) : null;
        var add = lines
          ? postJson(root + 'cart/add.js?moonbundle_ignore=true', { items: lines })
          : fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function () { return hasMb ? splitBundleLines() : null; });
        add
          .then(function () {
            btn && btn.classList.remove('is-loading');
            if (hasMb) openDrawer(); else window.location.href = root + 'cart';
          })
          .catch(function () { btn && btn.classList.remove('is-loading'); });
      });
    }
  }

  /* ---------- vidéo features & 4 raisons : lecture au clic ---------- */
  function initPlayers(root) {
    root.querySelectorAll('.pvf-video-player, .fr-video-player').forEach(function (p) {
      var video = p.querySelector('video');
      var overlay = p.querySelector('.pvf-play-overlay, .fr-play-overlay');
      var start = function () {
        if (!video) return;
        p.classList.add('is-playing');
        video.controls = true;
        video.play().catch(function () {});
      };
      overlay && overlay.addEventListener('click', start);
      video && video.addEventListener('click', function () { if (p.classList.contains('is-playing')) { video.paused ? video.play() : video.pause(); } else start(); });
    });
  }

  /* ---------- résultats avant/après ---------- */
  function initResults(root) {
    var swipers = {};
    root.querySelectorAll('.rc-tab-panel').forEach(function (panel) {
      var el = panel.querySelector('.swiper');
      if (!el || !window.Swiper) return;
      swipers[panel.id] = new Swiper(el, {
        spaceBetween: 16, slidesPerView: 'auto',
        breakpoints: { 1024: { spaceBetween: 32 } },
        pagination: { el: el.querySelector('.swiper-pagination'), type: 'bullets', clickable: true }
      });
    });
    var tabs = root.querySelectorAll('.rc-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        root.querySelectorAll('.rc-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
        var target = root.querySelector('#' + tab.getAttribute('data-rc-tab-target'));
        if (target) { target.classList.add('is-active'); swipers[target.id] && swipers[target.id].update(); }
      });
    });
  }

  /* ---------- 4 raisons : carrousel mobile ---------- */
  function initFourReasons(root) {
    var el = root.querySelector('.fr-features-mobile .swiper');
    if (el && window.Swiper) {
      new Swiper(el, {
        spaceBetween: 12, slidesPerView: 1,
        pagination: { el: el.querySelector('.swiper-pagination'), type: 'bullets', clickable: true },
        breakpoints: { 767: { slidesPerView: 2, spaceBetween: 16 }, 1024: { enabled: false } }
      });
    }
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    var items = root.querySelectorAll('.accordion-item');
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        items.forEach(function (o) { if (o !== item) { o.classList.remove('active'); var p = o.querySelector('.panel'); if (p) p.style.maxHeight = null; } });
        item.classList.toggle('active');
        var p = item.querySelector('.panel');
        if (p) p.style.maxHeight = p.style.maxHeight ? null : p.scrollHeight + 'px';
      });
    });
  }

  /* ---------- mur d'avis ---------- */
  function initReviews(root) {
    var more = root.querySelector('.pl-reviews-more');
    more && more.addEventListener('click', function () {
      var hidden = root.querySelectorAll('.pl-review-card.is-hidden');
      Array.prototype.slice.call(hidden, 0, 10).forEach(function (c) { c.classList.remove('is-hidden'); });
      if (root.querySelectorAll('.pl-review-card.is-hidden').length === 0) more.style.display = 'none';
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pl-main]').forEach(initMainProduct);
    document.querySelectorAll('.polar-video-features, .four-reasons').forEach(initPlayers);
    document.querySelectorAll('.reviews-carousel').forEach(initResults);
    document.querySelectorAll('.four-reasons').forEach(initFourReasons);
    document.querySelectorAll('.faq-outer').forEach(initFaq);
    document.querySelectorAll('.pl-reviews').forEach(initReviews);
  }

  ready(initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    if (s.querySelector('[data-pl-main]')) initMainProduct(s.querySelector('[data-pl-main]'));
    s.querySelectorAll('.polar-video-features, .four-reasons').forEach(initPlayers);
    s.querySelectorAll('.reviews-carousel').forEach(initResults);
    s.querySelectorAll('.four-reasons').forEach(initFourReasons);
    s.querySelectorAll('.faq-outer').forEach(initFaq);
    s.querySelectorAll('.pl-reviews').forEach(initReviews);
  });
})();
